import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "absolute",
    zIndex: 111,
    backgroundColor: "#000000",
    overflowY: "hidden",
    width: "100%",
    height: "100%",
  },
  bgImage: {
    width: "100%",
  },
  content: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    padding: theme.spacing.space16,
    boxSizing: "border-box",
  },
  rewardCard: {
    margin: `${theme.spacing.space40}px 0px`,
  },
  main: {
    height: "100%",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  rewards: {
    paddingBottom: theme.spacing.space100,
  },
  buttonGroup: {
    padding: `${theme.spacing.space16}px`,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.space16,
    paddingBottom: theme.spacing.space48,
    width: "100%",
    position: "absolute",
    bottom: 0,
    left: 0,
    boxSizing: "border-box",
    background: "rgba(255, 255, 255, 0.10)",
    backdropFilter: "blur(5px)",
  },
}));
